import { useNavigate } from 'react-router-dom';
import type { Playlist } from '@/types';

interface PlaylistCardProps {
    playlist: Playlist;
}

export function PlaylistCard({ playlist }: PlaylistCardProps) {
    const navigate = useNavigate();

    return (
        <div className="card h-100 shadow-sm hover-shadow transition-all cursor-pointer" onClick={() => navigate(`/playlists/${playlist.id}`)}>
            <div className="position-relative bg-body-tertiary card-img-top d-flex align-items-center justify-content-center" style={{ height: '160px' }}>
                {playlist.thumbnail ? (
                    <img src={playlist.thumbnail} className="w-100 h-100 object-fit-cover" alt={playlist.name} />
                ) : (
                    <i className="bi bi-music-note-beamed text-muted fs-1"></i>
                )}
                {playlist.currentTrack && playlist.currentTrack.isPlaying && (
                    <div className="position-absolute bottom-0 end-0 m-2 badge bg-success animate-pulse">
                        <i className="bi bi-play-circle-fill me-1"></i> Live
                    </div>
                )}
            </div>
            <div className="card-body d-flex flex-column">
                <h5 className="card-title text-truncate mb-1" title={playlist.name}>{playlist.name}</h5>
                <p className="card-text text-muted small flex-grow-1 line-clamp-2">
                    {playlist.description || 'No description'}
                </p>
                <div className="d-flex justify-content-between align-items-center mt-3 small text-muted">
                    <span>
                        <i className="bi bi-collection-play me-1"></i>
                        {playlist.metadata?.totalVideos || 0} tracks
                    </span>
                    <span>
                        <i className="bi bi-people me-1"></i>
                        {Object.keys(playlist.collaborators).length}
                    </span>
                </div>
            </div>
        </div>
    );
}
